import { useEffect, useState } from 'react'

import { warehouseApi } from '@/api/warehouse.api'

import { useDebounce } from './useDebounce'

export const useArticles = (search: string, enabled = true) => {
  const [data, setData] = useState<string[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<any>(null)

  const debouncedSearch = useDebounce(search, 300)

  useEffect(() => {
    if (!enabled) return

    const fetchArticles = async () => {
      setIsLoading(true)
      try {
        const response = await warehouseApi.getWarehouseArticles({
          name: debouncedSearch || undefined,
          limit: 100, // Fetch a reasonably large batch to de-duplicate on client
        })
        
        // Parse and de-duplicate unique part names
        const namesSet = new Set<string>()
        response.Articles.forEach(a => {
          namesSet.add(a.Name)
        })
        
        setData(Array.from(namesSet).sort())
        setError(null)
      } catch (err) {
        setError(err)
      } finally {
        setIsLoading(false)
      }
    }

    fetchArticles()
  }, [debouncedSearch, enabled])

  return { data, isLoading, error }
}
